"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get default () {
        return getTableNameAlias;
    },
    get getColumnNameAlias () {
        return getColumnNameAlias;
    }
});
const _inflection = /*#__PURE__*/ _interop_require_default(require("inflection"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getTableNameAlias(tableName, prefix, source) {
    var _inflection_source_inflection_table;
    let tn = tableName;
    if (source.isMeta(true) && !source.isMeta(true, 1) && prefix) {
        tn = tn.replace(prefix, '');
    }
    return (source == null ? void 0 : source.inflection_table) && ((_inflection_source_inflection_table = _inflection.default[source == null ? void 0 : source.inflection_table]) == null ? void 0 : _inflection_source_inflection_table.call(_inflection.default, tn)) || tn;
}
function getColumnNameAlias(columnName, source) {
    var _inflection_source_inflection_column;
    return (source == null ? void 0 : source.inflection_column) && ((_inflection_source_inflection_column = _inflection.default[source == null ? void 0 : source.inflection_column]) == null ? void 0 : _inflection_source_inflection_column.call(_inflection.default, columnName)) || columnName;
}
